import * as Sentry from '@sentry/browser';
// import {EventProcessor} from '@sentry/types/types/eventprocessor';
import {BrowserTracing} from '@sentry/tracing';
import {StoreController} from '../../store/controllers/StoreController';
import {sceneDataWithVersion} from '../../versions';
// import {Editor} from '../Editor';

function addSceneToEvent(event: Sentry.Event, hint?: Sentry.EventHint) {
	console.log(event, hint);
	try {
		const scene = StoreController.scene;
		const sceneData = sceneDataWithVersion(scene);
		console.log('add sceneData', sceneData);
		event.extra = {
			sceneData: JSON.stringify(sceneData),
		};
	} catch (err) {
		console.warn('failed to add scene data to event');
		console.error(err);
	}
	// Add anything to the event here
	// returning null will drop the event
	console.log(event);
}
export class ErrorsNotifier {
	static setup() {
		if (process.env.NODE_ENV != 'production') {
			console.log(`sentry NOT initialised (NODE_ENV=${process.env.NODE_ENV})`);
			return;
		}

		Sentry.init({
			dsn: 'https://4e4ff56fa8934b03be5b2ba051145947@o276149.ingest.sentry.io/1494410',
			integrations: [new BrowserTracing()],

			// Set tracesSampleRate to 1.0 to capture 100%
			// of transactions for performance monitoring.
			// We recommend adjusting this value in production
			tracesSampleRate: 1.0,
			beforeSend: (event, hint) => {
				addSceneToEvent(event);
				return event;
			},
		});

		// Sentry.configureScope(function (scope) {
		// 	console.log(scope);
		// 	scope.addEventProcessor(function (event, hint) {
		// 		addSceneToEvent(event)
		// 		return event;
		// 	});
		// });

		// const eventProcess:EventProcessor = (event: Sentry.Event)=>{
		// 	const client = Sentry.getCurrentHub().getClient();
		// }

		// Sentry.addGlobalEventProcessor((event: Event) => {
		// 	try {
		// 	  const client = Sentry.getCurrentHub().getClient();
		// 	  const endpoint = attachmentUrlFromDsn(
		// 		client.getDsn(),
		// 		event.event_id
		// 	  );
		// 	  const formData = new FormData();
		// 	  formData.append(
		// 		'my-attachment',
		// 		new Blob([JSON.stringify({ logEntries: ["my log"] })], {
		// 		  type: 'application/json',
		// 		}),
		// 		'logs.json'
		// 	  );
		// 	  fetch(endpoint, {
		// 		method: 'POST',
		// 		body: formData,
		// 	  }).catch((ex) => {
		// 		// we have to catch this otherwise it throws an infinite loop in Sentry
		// 		console.error(ex);
		// 	  });
		// 	  return event;
		// 	} catch (ex) {
		// 	  console.error(ex);
		// 	}
		//   });

		console.log('sentry initialized');
	}

	static updateMetadata() {
		const username = StoreController.editor.currentUser.username().value;
		if (!username) {
			console.warn('no username detected');
			return;
		}
		Sentry.setUser({username});
	}
}
